"use client";

import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import CalcFormButton from './controls/CalcFormButton';
import { ResponsiveFormField, ResponsiveFormLabel, ResponsiveFormInput } from './controls/ResponsiveFormField';

import { reasonOptions } from './reasonOptions';

const EntrypointForm = ({ onSubmit }) => {
    const [form, setForm] = useState({
        reason: 'minimize_payment',
        remainingBalance: null,
        currentInterestRate: null,
        originalLoanTerm: null,
        currentMonthlyPayment: null,
        includesTaxesInsurance: null,
        taxesInsuranceAmount: null,
        yearsToOwn: null
    });

    const loanTerms = [
        { label: '15 years', value: 15 },
        { label: '20 years', value: 20 },
        { label: '30 years', value: 30 }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleDropdownChange = (e) => {
        setForm({ ...form, originalLoanTerm: e.value });
    };

    const handleRadioChange = (e) => {
        setForm({ ...form, includesTaxesInsurance: e.value });
    };

    const handleSubmit = () => {
        console.log(form);
        if (onSubmit) {
            onSubmit(form);
        }
    }

    return (
        <div className="entry-form max-w-xl rounded-2xl overflow-auto bg-gray-lightest pb-5">
            <label htmlFor="reason" className="block text-center bg-primary text-white py-5 mb-7 font-extrabold">Why do you want to refinance?</label>
            <div className="form-group flex pb-2 mx-12">
                <Dropdown id="reason" value={form.reason} options={reasonOptions} onChange={handleDropdownChange} className="w-full" />
            </div>
            <ResponsiveFormField>
                <ResponsiveFormLabel htmlFor="remainingBalance">Remaining Balance</ResponsiveFormLabel>
                <ResponsiveFormInput>
                    <InputNumber id="remainingBalance" name="remainingBalance" value={form.remainingBalance} onValueChange={handleChange} mode="currency" currency="USD" minFractionDigits={0} maxFractionDigits={0}/>
                </ResponsiveFormInput>
            </ResponsiveFormField>
            <ResponsiveFormField>
                <ResponsiveFormLabel htmlFor="currentInterestRate">Current Interest Rate</ResponsiveFormLabel>
                <ResponsiveFormInput>
                    <InputNumber id="currentInterestRate" name="currentInterestRate" value={form.currentInterestRate} onValueChange={handleChange} mode="decimal" minFractionDigits={0} maxFractionDigits={0} suffix="%"/>
                </ResponsiveFormInput>
            </ResponsiveFormField>
            <ResponsiveFormField>
                <ResponsiveFormLabel htmlFor="originalLoanTerm">Original Loan Term</ResponsiveFormLabel>
                <ResponsiveFormInput>
                    <Dropdown id="originalLoanTerm" value={form.originalLoanTerm} options={loanTerms} onChange={handleDropdownChange} placeholder="Term"/>
                </ResponsiveFormInput>
            </ResponsiveFormField>
            <ResponsiveFormField>
                <ResponsiveFormLabel htmlFor="currentMonthlyPayment">Current Monthly Payment</ResponsiveFormLabel>
                <ResponsiveFormInput>
                    <InputNumber id="currentMonthlyPayment" name="currentMonthlyPayment" value={form.currentMonthlyPayment} onValueChange={handleChange} mode="currency" currency="USD" minFractionDigits={0} maxFractionDigits={0} />
                </ResponsiveFormInput>
            </ResponsiveFormField>
            <ResponsiveFormField>
                <ResponsiveFormLabel className='pl-5'>Does that include taxes & insurance?</ResponsiveFormLabel>
                <ResponsiveFormInput className='pl-5 sm:pl-0'>
                    <div className="flex">
                        <RadioButton inputId="includesYes" name="includesTaxesInsurance" value="yes" onChange={handleRadioChange} checked={form.includesTaxesInsurance === 'yes'} className="mr-1" />
                        <label htmlFor="includesYes" className="ml-1 mr-7">Yes</label>
                        <RadioButton inputId="includesNo" name="includesTaxesInsurance" value="no" onChange={handleRadioChange} checked={form.includesTaxesInsurance === 'no'} className="mr-1" />
                        <label htmlFor="includesNo">No</label>
                    </div>
                </ResponsiveFormInput>
            </ResponsiveFormField>
            {form.includesTaxesInsurance === 'yes' && (
                <ResponsiveFormField>
                    <ResponsiveFormLabel className='pl-5' htmlFor="taxesInsuranceAmount">How much is taxes/insurance?</ResponsiveFormLabel>
                    <ResponsiveFormInput className='pl-5 sm:pl-0'>
                        <InputNumber id="taxesInsuranceAmount" name="taxesInsuranceAmount" value={form.taxesInsuranceAmount} onValueChange={handleChange} mode="currency" currency="USD" minFractionDigits={0} maxFractionDigits={0}/>
                    </ResponsiveFormInput>
                </ResponsiveFormField>
            )}
            <ResponsiveFormField>
                <ResponsiveFormLabel htmlFor="yearsToOwn">How many more years do you plan to own this home?</ResponsiveFormLabel>
                <ResponsiveFormInput>
                    <InputNumber id="yearsToOwn" name="yearsToOwn" value={form.yearsToOwn} onValueChange={handleChange} />
                </ResponsiveFormInput>
            </ResponsiveFormField>
            <div className="form-group flex justify-center pb-2 mx-12 mt-2">
                <CalcFormButton label="Calculate" onClick={handleSubmit} />
            </div>
        </div>
    );
};

export default EntrypointForm;
